// Closes <details data-dropdown> menus on an outside click or Escape, and keeps only one open at a time.
// Without JavaScript they still open and close from their own summary.
export default function initDropdowns() {
	const dropdowns = () => document.querySelectorAll("details[data-dropdown][open]");

	document.addEventListener("click", (event) => {
		dropdowns().forEach((menu) => {
			if (!menu.contains(event.target)) menu.open = false;
		});
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape") return;
		dropdowns().forEach((menu) => {
			menu.open = false;
			menu.querySelector("summary")?.focus();
		});
	});
}
